import { setGeofenceStyles } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@casops/filters/types';
import MultiselectFilter from '../multiselect/MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import {
  ListGeofenceStyleModel,
  useListGeofenceStylesQuery,
} from '@casops/store/apis/geofenceStylesApi';

const useGeofenceStyleOptions = (): DropdownItemProps<string>[] => {
  const { data: geofenceStyles } = useListGeofenceStylesQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });

  return useMemo(() => {
    return geofenceStyles
      ? geofenceStyles.map(({ id, name }: ListGeofenceStyleModel) => {
          const value = id.toString();
          return { key: value, value, stringValue: value, label: name };
        })
      : [];
  }, [geofenceStyles]);
};

export const GeofenceStylesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();
  return (
    <MultiselectFilter<string>
      filterName="geofenceStyles"
      label={label ?? t('Fields.Filters.GeofenceStyle')}
      action={setGeofenceStyles}
      elementRef={elementRef}
      useItemsHook={useGeofenceStyleOptions}
    />
  );
};

export default GeofenceStylesFilter;
